
import { Box, Flex, Center, Text, Button as ChakraButton } from "@chakra-ui/react"
import CompanyBranchesForReports from "components/shared/CompanyBranches/CompanyBranchesForReports"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon/Icon"
import { useReportsContext } from "providers/ReportsProvider/ReportsProvider"
import { useUI } from "providers/UIProvider"
import { useEffect, useState } from "react"
import DateRangePicker from "../ReservationsTemplate/ReservationsToolbar/DateRangePicker/DateRangePicker"
import Checkbox from "components/UI/atoms/Checkbox"

import {
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
} from "@chakra-ui/react"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"
import DownloadReport from "./DownloadReport"


const SelectReportDate = () => {
  const { T } = useUI()
  const { userRole } = useAppContext()
  const { reportDates,
    handleDateChange,
    generateReport,
    handleStatusCheckboxClick,
    handleWasherCheckboxClick,
    handleSourcesCheckboxClick,
    handleBoxCountCheckbox,
    selectedStatusesForReports,
    selectedWashersForReports,
    selectedSourcesForReports,
    selectedBoxes,
    reportStatuses,
    reportSources,
    reportBoxes,
    reportWashers,
  } = useReportsContext()


  const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole);


  const reportDataNotCompleted = !reportDates[0] || !reportDates[1]

  const handleGenerateReport = () => {
    if (reportDates[0] && reportDates[1]) {
      generateReport(reportDates[0], reportDates[1])
    }
  }

  const [isDateSelected, setIsDateSelected] = useState(false);

  useEffect(() => {
    if (reportDates?.length === 0 || reportDates === null || reportDates === undefined) {
      setIsDateSelected(false)
    } else {
      setIsDateSelected(true)
    }
  }, [reportDates])


  //statuses
  const latestSelectedStatus = selectedStatusesForReports[selectedStatusesForReports.length - 1];
  const lastSelectedStatus = reportStatuses?.find(status => status.status === latestSelectedStatus)
  //washers
  const latestSelectedWasher = selectedWashersForReports[selectedWashersForReports.length - 1];
  const lastSelectedWasher = reportWashers?.find(washer => washer.washerEmployeeId === latestSelectedWasher)
  //sources
  const latestSelectedSource = selectedSourcesForReports[selectedSourcesForReports.length - 1];
  const lastSelectedSource = reportSources?.find(source => source.id === latestSelectedSource)
  //boxes

  const arrayTransformedBoxCount = Array.from({ length: reportBoxes }, (_, i) => i + 1)
  const lastIndex = selectedBoxes?.length - 1;
  const lastSelectedItem = selectedBoxes[lastIndex];

  // console.log(reportStatuses)
  // console.log(reportWashers)
  const buttonsWidth = isQappUser ? "170px" : "215px"
  return (
    <Box w="100%">
      <Flex width={"100%"} mt="25px" gap={2}>
        {!isDateSelected &&
          <>
            <Text style={{
              position: "absolute",
              zIndex: 1,
              pointerEvents: "none",
              marginLeft: "9px",
              marginTop: "10px",
              fontSize: "14px",
              color: "black",
              fontWeight: 500
            }}>{T("bookings.toolbar.choose_dates")}</Text>
            <Box style={{ position: "absolute", marginLeft: "170px", zIndex: 1, pointerEvents: "none", marginTop: "10px" }}>
              <Icon name="calendar_month" iconStyles={{ width: "20px", height: "20px", }} />
            </Box>
          </>
        }
        <DateRangePicker
          propsConfigs={{
            triggerBtnProps: !isDateSelected && {
              color: "#FFF",
              _hover: {
                backgroundColor: "#FFF"
              },
              _focus: {
                backgroundColor: "#FFF"
              },
              width: "200px"
            },

          }}
          handleSelect={handleDateChange}
          selectedDates={reportDates ? reportDates : []} />
        {isQappUser && <Box style={{ marginTop: "-10px", marginBottom: "10px", width: "200px" }}>
          <CompanyBranchesForReports width="200px" />
        </Box>
        }
        <Menu closeOnSelect={false}>
          <MenuButton as={ChakraButton} style={{ backgroundColor: "white", color: "black", width: buttonsWidth, height: "44px", border: "2px solid #E9F2FD" }}>
            <Flex alignItems="center" justifyContent="space-between" gap="3">
              {selectedBoxes.length > 0 ? lastSelectedItem : T("bookings.toolbar.box")}
              <Icon name="dropdown" iconStyles={{ fill: "#00000", width: "10px", height: "10px" }} />
            </Flex>
          </MenuButton>
          <MenuList minWidth='180px' overflowY="auto" maxHeight="300px">
            <MenuOptionGroup type='checkbox'>
              {arrayTransformedBoxCount.map((box: number) => (
                // <MenuItemOption
                //   key={box}
                //   isChecked={selectedBoxes.includes(box)}
                //   onChange={() => handleBoxCountCheckbox(box)}
                //   value={box.toString()}
                // >{box}</MenuItemOption>
                <Box key={box} onClick={(e: any) => {
                  handleBoxCountCheckbox(box)
                  e.preventDefault()
                }} cursor="pointer">
                  <Checkbox
                    key={box}
                    isChecked={selectedBoxes.includes(box)}
                    onChange={() => { }} ////
                    label={box.toString()}
                  />
                </Box>
              ))}
            </MenuOptionGroup>
          </MenuList>
        </Menu>

        <Menu closeOnSelect={false}>
          <MenuButton as={ChakraButton} style={{
            backgroundColor: "white",
            color: "black",
            height: "44px",
            width: buttonsWidth,
            border: "2px solid #E9F2FD",
            borderRadius: "10px"
          }}>
            <Flex alignItems="center" justifyContent="space-between" gap="3">
              {selectedWashersForReports.length > 0 ? lastSelectedWasher?.washerEmployee.substring(0, 12) : T("reports.toolbar.washers")}
              <Icon name="dropdown" iconStyles={{ fill: "#00000", width: "10px", height: "10px" }} />
            </Flex>

          </MenuButton>
          <MenuList minWidth='240px' overflow="auto" maxHeight="300px" >
            <MenuOptionGroup type='checkbox' >
              {reportWashers?.map((reportWasher: any) => (
                <Box key={reportWasher.washerEmployeeId}
                  onClick={(e: any) => {
                    handleWasherCheckboxClick(reportWasher.washerEmployeeId)
                    e.preventDefault()
                  }}
                  cursor="pointer" >
                  <Checkbox
                    key={reportWasher.washerEmployeeId}
                    isChecked={selectedWashersForReports.includes(reportWasher.washerEmployeeId)}
                    onChange={() => { }}
                    label={reportWasher.washerEmployee}
                  // value={statusGroup.status}
                  />
                </Box>
              ))}
            </MenuOptionGroup>
          </MenuList>
        </Menu>

        <Menu closeOnSelect={false}>
          <MenuButton as={ChakraButton} style={{
            backgroundColor: "white",
            color: "black",
            height: "44px",
            width: buttonsWidth,
            border: "2px solid #E9F2FD",
            borderRadius: "10px"
          }}>
            <Flex alignItems="center" justifyContent="space-between" gap="3">
              {selectedStatusesForReports.length > 0 ? lastSelectedStatus?.statusText : T("reports.toolbar.status")}
              <Icon name="dropdown" iconStyles={{ fill: "#00000", width: "10px", height: "10px" }} />
            </Flex>

          </MenuButton>
          <MenuList minWidth='240px'>
            <MenuOptionGroup type='checkbox'>
              {reportStatuses?.map((statusGroup: any) => (
                <Box key={statusGroup.status} cursor="pointer" onClick={(e: any) => {
                  handleStatusCheckboxClick(statusGroup.status)
                  e.preventDefault()
                }}>
                  <Checkbox
                    key={statusGroup.status}
                    isChecked={selectedStatusesForReports.includes(statusGroup.status)}
                    onChange={() => { }}
                    label={statusGroup.statusText}
                  // value={statusGroup.status}
                  />
                </Box>
              ))}
            </MenuOptionGroup>
          </MenuList>
        </Menu>



        <Menu closeOnSelect={false}>
          <MenuButton as={ChakraButton} style={{
            backgroundColor: "white",
            color: "black",
            height: "44px",
            width: buttonsWidth,
            border: "2px solid #E9F2FD",
            borderRadius: "10px"
          }}>
            <Flex alignItems="center" justifyContent="space-between" gap="3">
              {selectedSourcesForReports.length > 0 ? lastSelectedSource?.name : T("reports.toolbar.reservation_type")}
              <Icon name="dropdown" iconStyles={{ fill: "#00000", width: "10px", height: "10px" }} />
            </Flex>

          </MenuButton>
          <MenuList minWidth='240px'>
            <MenuOptionGroup type='checkbox'>
              {reportSources?.map((reportSource: { id: number, name: string }) => (
                <Box key={reportSource.id} cursor="pointer" onClick={(e: any) => {
                  handleSourcesCheckboxClick(reportSource.id)
                  e.preventDefault()
                }}>
                  <Checkbox
                    key={reportSource.id}
                    isChecked={selectedSourcesForReports.includes(reportSource.id)}
                    onChange={() => { }}
                    label={reportSource.name}
                  //@ts-ignore
                  // value={reportSource.id}
                  />
                </Box>
              ))}
            </MenuOptionGroup>
          </MenuList>
        </Menu>
      </Flex>
      <Flex style={{
        justifyContent: "space-between",
        alignItems: "center",
        gap: 5,
        flexDirection: "row",
        width: "125%",
        height: "100%",
        marginLeft: "-9px"
      }}>
        <Center mt="30px">
          <Button
            text={T("extract_report.form.button_generate")}
            onClick={handleGenerateReport}
            styles={{ width: "280px", height: "80px", fontSize: "18px" }}

            isDisabled={reportDataNotCompleted}
          />
        </Center>
        <DownloadReport />
      </Flex>
    </Box>
  )
}

export default SelectReportDate
